import { render } from "./ToDoContent.vue?vue&type=template&id=cdb57cd0&ts=true"
import script from "./ToDoContent.vue?vue&type=script&lang=ts"
export * from "./ToDoContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__